module.exports = __webpack_public_path__ + "img/example_sado_estuary_a1.aaecd9d0.jpg";